import { DraftConfiguration, DraftState, PrintType } from '@/types';
import { getConfiguration } from '@/model/draft/getConfiguration';
import { getConfigurationsForPrintTypeAlignment } from '@/model/draft/getConfigurationsForPrintTypeAlignment';
import { isDigital } from '@/model/printType/isDigital';
import { SpecialFlex } from '@/model/printType/printTypes';
import { DraftWarning } from '../types';
import { changePrintType } from './helper/changePrintType';

export const setPrintTypeAction =
  ({ cid }: DraftConfiguration, newPrintType: PrintType) =>
  (draft: DraftState) => {
    const configuration = getConfiguration(draft, cid);
    const [otherConfigurations, includesOtherSleeve] = getConfigurationsForPrintTypeAlignment(
      draft,
      configuration
    );

    const existingPrintType = configuration.printType;
    const configurations = [configuration, ...otherConfigurations];
    const printTypeIds = configurations.map((configuration) => configuration.printType.id);

    changePrintType(configuration, newPrintType);

    if (
      otherConfigurations.length > 0 &&
      isDigital(existingPrintType) !== isDigital(newPrintType)
    ) {
      otherConfigurations.forEach((configuration) => changePrintType(configuration, newPrintType));

      draft.warnings[otherConfigurations[0].cid] = includesOtherSleeve
        ? DraftWarning.EqualizedSleevesOnSwitch
        : DraftWarning.EqualizedOnSwitch;
    }

    if (
      newPrintType.id === SpecialFlex &&
      printTypeIds.some(
        (printTypeId, index) =>
          // check if any configuration with multiple color layers has been switched to special flex
          printTypeId !== SpecialFlex &&
          configurations[index].printType.id === SpecialFlex &&
          configurations[index].printColors.length > 1
      )
    ) {
      draft.warnings[cid] = DraftWarning.ChangeAllDesignColors;
    }
  };
